/**
 * Allows for collapse button to display different text on open vs close
 * 
 * Values:
 * - openText: text displayed when the div is collapsed
 * - closeText: text displayed when the div is open
 * 
 * Example:
 * .outcome-feedback{data: {controller: "customizable-collapse",
      "customizable-collapse": {"open-text-value": t("common.view_feedback"),
                                "close-text-value": t("common.close_feedback")}}}
      .collapse{id: "#{example}_example"}
        .content-to-collapse
      %button.btn..collapsed{type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "##{example}_example",
        "aria-expanded": "false",
        data:{"customizable-collapse-target": "button",
              action: "customizable-collapse#onClick" }}
        = t("common.view_feedback")
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    openText: String,
    closeText: String,
  };

  static get targets() {
    return ["button"];
  }

  onClick() {
    if (this.buttonTarget.classList.contains("collapsed")) {
      this.buttonTarget.textContent = this.openTextValue;
    } else {
      this.buttonTarget.textContent = this.closeTextValue;
    }
  }
}
